import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import OperatingSystem from "../../Components/OperatingSystem";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function DedicatedServerSingapore() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Dedicated Server Singapore | High Performance Hosting";
    sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
     <Helmet>
        <title>Dedicated Server Singapore | High Performance Hosting</title>
        <meta name="description" content="Get reliable dedicated servers in Singapore with high speed, full root access, and 24/7 support. Ideal for enterprises and high-traffic websites." />
        <meta name="keywords" content="Dedicated Server, Dedicated Server Hosting Singapore, Managed Dedicated Server, Dedicated Server Singapore" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-singapore`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-singapore`} />
        <meta property="og:title" content="Powerful and Secure Dedicated Server in Singapore" />
        <meta property="og:description" content="Get the best dedicated server in Singapore. Providing customizable server configurations, elite security and high uptime to businesses wanting dedicated assets." />
     </Helmet>
      <section className="banner-bg bg-dark control-panel-banner slash-banner-part">
        <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-7 col-xl-6">
                  <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Reliable. Secure. Dedicated.
                  </span>
                  <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Dedicated Server Singapore: Your Passport to Asia
                  </h1>
                  <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Downtime? That’s in 2010. Get a dedicated server Singapore that works just like virtual assistants-quick, focused, and ready for everything. Even if you are launching, adjusting, or ruling your niche, we’ll keep your backend as sharp as your grind.</p>
                  <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                          <span className="btn-arrow__text">
                              Get Started
                              <span className="btn-arrow__icon">
                                  <i className="fa-solid fa-arrow-right"></i>
                              </span>
                          </span>
                      </button>
                      <MinPlanPrice category="customizeddsin" />
                  </div>
                 <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
              </div>
              <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                  <img src="images/you-hustle-hard-your-dedicated.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
              </div>
          </div>
        </div>
      </section>

      <div className="container pt-100 pb-100">
        <div className="row">
            <div className="col-12">
                <div className="bg-grey pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-10 col-lg-11 col-xl-5">
                            <h2>
                                 Singapore Server: You’ll Be Like, “That’s the One.”
                            </h2>
                            <p className="mb-8 text-opacity-75">
                                Maybe you are all set to dump slow loading? Our dedicated server hosting Singapore is so efficient and trustworthy, 24/7.
                            </p>
                        </div>
                        <div className="col-xl-7">
                            <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/claim-your-power.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4">
                                            Claim Your Power
                                        </h6>
                                        <p className="mb-0 text-opacity-50">
                                            This is your digital realm-own it with a dedicated server Singapore that bends to your every demand.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/glow-with-10-gbps.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4">
                                            Glow with 10 Gbps Speed
                                        </h6>
                                        <p className="mb-0 text-opacity-50">
                                            Give farewell to lag and hello to dominant speed. Your users will feel the huge difference in no time.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/control-freak-perfect.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4">
                                            Control Freak? Perfect.
                                        </h6>
                                        <p className="mb-0 text-opacity-50">
                                            Why wait too long for someone else’s control? Grab admin power and guide your server exactly where you need it.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/next-level-flex.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4">
                                            Next-Level Flex: You In?
                                        </h6>
                                        <p className="mb-0 text-opacity-50">
                                            Why waste time when you are paying? Your best dedicated server in Singapore will always be up and running.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/hustle-hard-host-harder.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4">
                                            Hustle Hard, Host Harder
                                        </h6>
                                        <p className="mb-0 text-opacity-50">
                                            We engineered this dedicated server Singapore to keep high speed with your struggles. Trustworthy and quick.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/own-the-spotlight.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4">
                                            Own the Spotlight
                                        </h6>
                                        <p className="mb-0 text-opacity-50">
                                            Don’t always keep up-just lead the way with the best dedicated server in Singapore, that’s all about high speed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1 filtered-image" />
                </div>
            </div>
        </div>
      </div>

      <section className="price-plan-section pt-100 pb-100 position-relative">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Hosting Plans That’s Just For You.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizeddsin'}/>
      </section>

      <section className="pt-100 pb-100">
        <div className="container">
            <div className="bg-white px-8 py-10 rounded-3">
                <div className="row align-items-center g-4">
                    <div className="col-lg-5">
                        <img src="/images/why-go-far-when-your-ideal.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                    </div>
                    <div className="col-lg-7 ipad-mt">
                        <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                              <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Your Site Deserves VIP Treatment
                            </small>
                        </div>
                        <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Why Go Far When Your Ideal Server Could Be Next Door?</h2>
                        <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> Closer servers = blazing-fast speed, easy vibes, and no lag issues. Pick the perfect location that’s closer to you and let your website do the talking-fast, clean, and on point.</p>
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate mt-5 btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <span className="btn-arrow__text">
                                  View All Plans
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </button>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="pb-40">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Setups Made so Simple
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Your Site Flopping? Not With Dedicated Server Singapore!</h2>
                        <p className="text-dark mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Tired of babysitting your site? Let it run seamlessly, powerfully, and hassle-free.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Let’s Be Genuine: Lag Always Kills the Vibe</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/let’s-be-genuine.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">You’ve got the product, the audience, all the hype… But your site’s folding just like a low-cost chair? So, get your hands on a Singapore dedicated server and serve them high speed.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">From ‘Just Offline’ to ‘Just Dropped’ in a Click</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/from-‘just-offline.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Big ideas don’t deserve to be held back by boring tech. With our Dedicated Server Hosting Singapore, it’s all about a single click & boom-you’re online. No waiting, no coding issues.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Fast Enough to Break the Internet</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/fast-enough-to-break.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">In an era where attention spans are shorter than Reels, speed is what captures interest. The best dedicated server in Singapore offers high load times. Laggy sites are so last reason.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Strong Core, Smart Tech: That’s Singapore</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/strong-core-smart.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">If your business is serious, then make sure that your server is too. With the enterprise-level hardware of Singapore hosting, you get exceptional strength and high flow. No fragile links.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Support That Never Left on Read</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/support-that-never.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Tech collapse hit hard-but waiting too long for support? Nah. With our dedicated server Singapore, our experts are always on, responsive, and never leave you on seen.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Full Access to Your Server Realm</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/full-access-to-your-server.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Sick of “you can’t do that here?” But not with us. With full access, every single door opens. Ideal for those who like to twist and own their backend. It’s giving freedom.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Custom Just Like Your Coffee Order</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">07</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/custom-just-like-your.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our dedicated server in Singapore allows you to tweak & refine every inch of setup. Complete freedom, no question. Wanna DIY? Just do it. Wanna chill? We’ll manage the tech.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Inbox Detox Starts Right Now</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">08</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/inbox-detox-starts.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">No one’s got too much time to fight spam every day. With our strong security, you’ll always get the right stuff. Peace of mind hits really differently when your mails behave well.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <OperatingSystem />

      <section className="pt-60 pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">Ready for the Spotlight?</small>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">No More ‘On The Way’. Make It Happen Now!</h2>
                            <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Every Site Deserves Star Treatment: Let’s Begin with Our Servers. </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <Link to="#" onClick={handlePlanClick}  className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Start Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                            <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Learn More
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
}
